import { useId } from 'react'
import { Stack, Text, Modal, IconButton } from '@fluentui/react'
import { ConversationDetail } from '../../api/models'
import LoadingSpinner from '../common/LoadingSpinner'
import ConversationDetailView from './ConversationDetailView'

export type ConversationModalContent =
  | { kind: 'loaded'; conversation: ConversationDetail }
  | { kind: 'loading' }
  | { kind: 'unavailable'; message: string }

type ConversationModalProps = {
  content: ConversationModalContent | null
  onDismiss: () => void
}

const titleFor = (content: ConversationModalContent): string => {
  switch (content.kind) {
    case 'loaded':
      return content.conversation.title || '(untitled)'
    case 'loading':
      return 'Loading conversation'
    case 'unavailable':
      return 'Conversation unavailable'
  }
}

const ConversationModalBody = ({ content }: { content: ConversationModalContent }) => {
  switch (content.kind) {
    case 'loaded':
      return <ConversationDetailView conversation={content.conversation} />
    case 'loading':
      return <LoadingSpinner label="Loading conversation..." />
    case 'unavailable':
      return (
        <Text styles={{ root: { color: '#a19f9d', textAlign: 'center', padding: 40 } }}>{content.message}</Text>
      )
  }
}

const ConversationModal = ({ content, onDismiss }: ConversationModalProps) => {
  const titleId = useId()

  return (
    <Modal
      isOpen={content !== null}
      onDismiss={onDismiss}
      isBlocking={false}
      titleAriaId={titleId}
      styles={{
        main: {
          maxWidth: 800,
          width: '90vw',
          maxHeight: '85vh',
          padding: 24,
          borderRadius: 8,
        },
      }}
    >
      {content && (
        <Stack tokens={{ childrenGap: 16 }}>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Text id={titleId} variant="xLarge" styles={{ root: { fontWeight: 600 } }}>
              {titleFor(content)}
            </Text>
            <IconButton iconProps={{ iconName: 'Cancel' }} ariaLabel="Close" onClick={onDismiss} />
          </Stack>
          <ConversationModalBody content={content} />
        </Stack>
      )}
    </Modal>
  )
}

export default ConversationModal
